var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#777778;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.49,11.25l-1.43-.82c.71-1.25,1.39-2.49,2.11-3.69a1.19,1.19,0,0,0,0-1.56,3.19,3.19,0,0,1,.53-4.13A3.36,3.36,0,0,1,11.9.75a3.34,3.34,0,0,1,1.14,4A3.35,3.35,0,0,1,9.12,6.68Zm5.14-7.77a1.65,1.65,0,1,0-3.29,0,1.65,1.65,0,1,0,3.29,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.3,12.71,11.71,8.16l1.44-.82,2.59,4.51a3.39,3.39,0,0,1,4.1,2.37,3.28,3.28,0,0,1-1.67,3.84,3.33,3.33,0,0,1-4.07-.81A3.41,3.41,0,0,1,14.3,12.71Zm2.32,4.07A1.67,1.67,0,1,0,15,15.09,1.67,1.67,0,0,0,16.62,16.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.71,14.28v1.65H9.16c-.69,0-1.37,0-2.06,0a.65.65,0,0,0-.73.47,3.27,3.27,0,0,1-3.75,2A3.35,3.35,0,0,1,0,15.14a3.3,3.3,0,0,1,2.68-3.28c1.64-.37,3.12.55,3.87,2.42Zm-8.39,2.5A1.68,1.68,0,0,0,5,15.13a1.71,1.71,0,0,0-1.65-1.69,1.67,1.67,0,1,0,0,3.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefer);
export default __webpack_public_path__ + "static/media/refer.938d297acbfc7145870c34e379a6491e.svg";
export { ForwardRef as ReactComponent };